import React, { useEffect, useMemo, useState } from 'react';
import { List, Popover, Modal, ConfirmOptions } from "tea-component";
import { delMenu, moveMenu, updateMenuSort } from '@/pages/dashboard/services/leftMenu';
import { useIntl, useDispatch, getLocale, useSelector } from 'umi';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { BUSINESS_TYPE_MYDASHBOARD, FOLDER_NAME_FAVORITES, FOLDER_NAME_MYDASHBOARD } from '@/pages/dashboard/_config/constant';
export default (props: any) => {
  const { item, item: { onclick = '' }, visible, setVisible, folder, referenceElement, setModalInfoState, moveToMenu } = props;
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const locale = getLocale();
  // const [visible, setVisible] = useState<boolean>(false);
  const { currentGame } = useSelector(state => {
    // @ts-ignore
    const { currentGame } = state.dashboard;
    return {
      currentGame,
    }
  });
  const hasArrow = item?.dashoboard_list?.length;
  // 上下移动菜单（子目录级别间移动）
  // const orderToMenu = { ...folder, dashoboard_list: folder?.dashoboard_list?.filter((dash: any) => dash?.menu_type === '3') }

  const orderToMenu = useMemo(() => {
    return { ...folder, dashoboard_list: folder?.dashoboard_list?.filter((dash: any) => dash?.menu_type === '3') }
  }, [folder]);

  const hancleClickRename = () => {
    setModalInfoState({
      show: true,
      type: 'edit',
      editType: 'subfolder',
      item: { ...item }
    });
    setVisible(false);
  }

  const hancleClickDel = () => {
    const name = (locale === 'zh-CN' && item?.name_cn) || item?.name_en;
    setVisible(false);
    Modal.confirm({
      message: <div style={{ fontSize: '16px', fontWeight: '400' }}>
        <div style={{ fontWeight: 'bold' }}>
          {formatMessage({ id: 'menu_info_del_1' }) + formatMessage({ id: 'subfolder' })}?
        </div>
        <div style={{ marginTop: '5px' }}>
          {formatMessage({ id: 'menu_info_del_2' })}
          <span style={{ fontWeight: 'bold' }}>{name}</span> ?
          <span> {formatMessage({ id: 'menu_info_del_3' })}</span>
        </div>
      </div>,
      okText: formatMessage({ id: 'menu_confirm' }),
      cancelText: formatMessage({ id: 'menu_cancel' }),
      onOk: doDelMenu
    } as ConfirmOptions);
  }

  const handleMoveToMenu = (folderId: string, targetId: string) => {
    setVisible(false);
    Modal.confirm({
      message: <div style={{ fontSize: '16px', fontWeight: '400' }}><span>{formatMessage({ id: 'menu_info_move' })}</span></div>,
      okText: formatMessage({ id: 'menu_confirm' }),
      cancelText: formatMessage({ id: 'menu_cancel' }),
      onOk: () => { doMoveMenu(folderId, targetId) }
    } as ConfirmOptions);
  }

  // 移动folder
  const doMoveMenu = (folderId: string, targetId: string) => {
    moveMenu({
      id: item.id,
      game_code: currentGame?.game_code,
      target_menu_id: targetId
    }).then(() => {
      dispatch({
        type: 'dashboard/getLeftMenuList',
      });
    }, (err) => {
    }).finally(() => {
    });
  }

  // 删除folder
  const doDelMenu = () => {
    delMenu({
      id: item.id,
      game_code: currentGame?.game_code,
    }).then(() => {
      dispatch({
        type: 'dashboard/getLeftMenuList',
      });
    }, (err) => {
    }).finally(() => {
    });
  }

  const menuInfo = useMemo(() => {
    const isFavorite = orderToMenu?.business_type === BUSINESS_TYPE_MYDASHBOARD && orderToMenu?.name_en === FOLDER_NAME_FAVORITES;
    const index = (orderToMenu?.dashoboard_list || []).findIndex((dashboard: any) => {
      return dashboard && dashboard?.id === item?.id;
    });
    const isFirst = index === 0;
    const isLast = index === (orderToMenu?.dashoboard_list.length - 1);
    return {
      isFavorite,
      isFirst,
      isLast,
      index: index
    }
  }, [orderToMenu, item]);
  const { isFavorite, isFirst, isLast } = menuInfo;

  const handleClickShiiftUP = () => {
    setVisible(false);
    const preDashboard = orderToMenu?.dashoboard_list?.[menuInfo.index - 1];
    if (!preDashboard) {
      return;
    }
    doUpdateMenuSort(preDashboard.id);
  }

  const handleClickShiiftDown = () => {
    setVisible(false);
    const nextDashboard = orderToMenu?.dashoboard_list?.[menuInfo.index + 1];
    if (!nextDashboard) {
      return;
    }
    doUpdateMenuSort(nextDashboard.id);
  }

  // shift up, shift down
  const doUpdateMenuSort = (targetId: string) => {
    updateMenuSort({
      id: item.id,
      target_menu_id: targetId,
      game_code: currentGame?.game_code,
    }).then(() => {
      dispatch({
        type: 'dashboard/getLeftMenuList',
      });
    }).catch(e=>{
			console.log(e)
		})
  }

  useEffect(() => {
    if (visible) {
      dispatch({
        type: "dashboard/save",
        payload: {
          showContentMask: true
        }
      });

      dispatch({
        type: 'home/save',
        payload: {
          showGlobalMask: 'transparent',
        },
      });
    } else {
      dispatch({
        type: "dashboard/save",
        payload: {
          showContentMask: false
        }
      });

      dispatch({
        type: 'home/save',
        payload: {
          showGlobalMask: false,
        },
      });
    }
    // setActiveInfo && setActiveInfo({
    //   id: item?.id,
    //   show: visible,
    // })

    return () => {
      dispatch({
        type:"dashboard/save",
        payload: {
          showContentMask: false
        }
      });

      dispatch({
        type: 'home/save',
        payload: {
          showGlobalMask: false,
        },
      });
    }
  }, [visible]);

  return (
    <>
      {/*<div className={onclick === 'true' ? "left-nav-hd left-nav-subfolder-newhidden" : "left-nav-hd"}>*/}
      {/*  <span className="left-nav-title">{text}</span>*/}
      {/*  {showNew ? <span className="left-nav-notice">NEW</span> : ""}*/}
      {/*</div>*/}
      {onclick === 'true' && <Popover
        referenceElement={referenceElement}
        visible={visible}
        onVisibleChange={val => setVisible(val)}
        placement="right-start"
        placementOffset={hasArrow ? [-10, 56] : [-10, 56]} //[-10, 32]
        trigger="click"
        overlay={
          <div className='left-nav-exit' onClick={(e) => {
            e.stopPropagation();
            return false;
          }}>
            <List type="option">
              <List.Item onClick={hancleClickRename}><div className='dbd-sub-nav'><SvgIcon type='rename-icon' className='dbd-sub-nav-icon'/><div className="dbd-sub-nav-text" >{formatMessage({ id: 'menu_rename' })}</div></div></List.Item>
              {!item?.dashoboard_list?.length && <List.Item onClick={hancleClickDel}><div className='dbd-sub-nav'><SvgIcon type='trash-can-icon' className='dbd-sub-nav-icon'/><div className="dbd-sub-nav-text" >{formatMessage({ id: 'menu_delete' })}</div></div></List.Item>}
              <Popover
                placement="right-start"
                placementOffset={[0, 8]}
                overlay={<div className='tea-dropdown-box dbd-menu-option'>
                  <List type="option">
                    {(moveToMenu || [])?.map((folder: any) => {
                      return <List.Item
                        disabled={folder?.id === item?.parent_id || folder?.name_en === FOLDER_NAME_MYDASHBOARD || folder?.name_en === FOLDER_NAME_FAVORITES}
                        key={folder?.id}
                        onClick={() => { handleMoveToMenu(folder?.id, folder?.id) }}>
                        {locale === 'zh-CN' && folder?.name_cn || folder?.name_en}
                      </List.Item>
                    })}
                  </List>
                </div>
                }
              >
                <List.SubMenu label={<div className='dbd-sub-nav'><SvgIcon type='file-move-icon' className='dbd-sub-nav-icon'/><div className="dbd-sub-nav-text" >{formatMessage({ id: 'menu_move_to' })}</div></div>}></List.SubMenu>
              </Popover>
              <Popover
                placement="right-start"
                placementOffset={[0, 8]}
                // trigger={"click"}
                overlay={<div className='tea-dropdown-box'>
                  <List type="option">
                    <List.Item onClick={handleClickShiiftUP} disabled={isFirst}>
                      <div className={`dbd-sub-nav ${isFirst?'disabled':''}`}><SvgIcon type='rising-arrow-icon' className='dbd-sub-nav-icon'/><div className="dbd-sub-nav-text"> {formatMessage({ id: 'menu_shift_up' })}</div></div>
                    </List.Item>
                    <List.Item onClick={handleClickShiiftDown} disabled={isLast}>
                      <div className={`dbd-sub-nav ${isLast?'disabled':''}`}><SvgIcon type='down-arrow-icon' className='dbd-sub-nav-icon'/><div className="dbd-sub-nav-text"> {formatMessage({ id: 'menu_shift_down' })}</div></div>
                    </List.Item>
                  </List>
                </div>
                }
              >
                <List.SubMenu label={<div className='dbd-sub-nav'><SvgIcon type='order-icon' className='dbd-sub-nav-icon'/><div className="dbd-sub-nav-text">{formatMessage({ id: 'menu_order' })}</div></div>}></List.SubMenu>
              </Popover>
            </List>
          </div>
        }
      >
        {/*<span*/}
        {/*  className={hasArrow ? 'left-nav-absolute left-nav-mr' : 'left-nav-absolute'}*/}
        {/*  onClick={(e) => {*/}
        {/*    e.stopPropagation();*/}
        {/*    return false;*/}
        {/*  }}>*/}
        {/*  <SvgIcon type="more" />*/}
        {/*</span>*/}
      </Popover>}
    </>
  );
}
